var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrowDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 10,
    viewBox: "0 0 7 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.55508 5L0.666016 1.11094L1.77695 0L6.77695 5L1.77695 10L0.666016 8.88906L4.55508 5Z",
    fill: "#63658E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowDark);
export default __webpack_public_path__ + "static/media/rightArrowDark.78d983aa166933a295325debcf6a34f4.svg";
export { ForwardRef as ReactComponent };